import React from "react";

const GlobalChatNotifications = () => {
    return null;
};

export default GlobalChatNotifications;